var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreveilLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "101.8px",
    height: "39.3px",
    viewBox: "0 0 101.8 39.3",
    style: {
      enableBackground: "new 0 0 101.8 39.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#313841;}\n\t.st1{fill:#F0602B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,14H5v5.6H0.8V1.2h7.5c4.5,0,6.1,1.8,6.1,5.2v2.4C14.4,12.2,12.6,14,8.1,14z M10.3,6.8 c0-1.3-0.5-1.9-2.2-1.9H5v5.5h3.1c1.8,0,2.2-0.7,2.2-2V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,13.8h-2.4v5.7h-4.1V1.2h7.6c4.5,0,6.1,1.8,6.1,5.2v2.3c0,2.3-0.8,3.8-2.7,4.6l4.4,6.3h-4.9L23.3,13.8z  M26.4,6.8c0-1.4-0.5-1.9-2.2-1.9h-3.3v5.4h3.3c1.8,0,2.2-0.6,2.2-2V6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,19.5V1.2h11.5v3.7H38v3.4h6.8V12H38v4h7.4v3.7H33.8V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.5,19.5h-5.9L47.4,1.2h4.2l3.9,14.6l3.9-14.6h4.2L58.5,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.8,19.5V1.2h11.5v3.7h-7.4v3.4h6.8V12h-6.8v4h7.4v3.7H65.8V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,19.5V1.2h4.1v18.4h-4.1V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.4,19.5V1.2h4.1v14.7h7.3v3.7H89.4V19.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,34.7h1.8c2.5,0,2.5-1.5,2.5-3.2v-4.4H4.7v4.4C4.7,33.3,4.7,34.7,7.3,34.7z M7.1,29.5h2.1v2.9H7.1V29.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37.7,36.1 42.3,36.1 42.3,33.6 40.1,33.6 40.1,29.6 45.4,29.6 45.4,27.2 37.7,27.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.8,23.2v8.4c0,4.8,2,7.1,6.2,7.1h2.3c4.1,0,6.2-2.5,6.2-7.3v-1.8h18.2v4h-2.4v2.5h4.8v-8.9H12.9v4.2 c0,4-1.5,4.8-3.7,4.8H7c-2.4,0-3.7-0.8-3.7-4.6v-5.9h42.1v-2.5H0.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreveilLogo);
export default __webpack_public_path__ + "static/media/preveil-logo.2b42ffa1d6d59ebca0f1f43b88dbb1c3.svg";
export { ForwardRef as ReactComponent };